import styled from 'styled-components';
import OrangeArrowIcon from "../../../assests/images/orangeicon.svg";

export const YourBadgeSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 50px 0px 54px;
`;

export const BadgeWrap = styled.div`
    max-width: 996px;
    padding: 20px;
    background: #FFFFFF;
    margin: 0 auto;
    border-radius: 15px;
    box-shadow: 0px 20px 20px #0000001A;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 35px;

    @media screen and (max-width: 767px){
        flex-direction: column;
        row-gap: 20px;
    }
`;

export const BadgeContent = styled.div`
    width: 100%;
    max-width: 558px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
`;

export const BadgeTitle = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 20px;
`;

export const BadgeText = styled.p`
    margin-bottom: 0px;
`;
export const BadgeTextSpan = styled.span`
    color: #333333;
    font-size: 38px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 54px;
    margin-bottom: 0px;
    display: block;
    
    @media screen and (max-width: 991px){
            font-size: 32px;
            line-height: 52px;
    }

    @media screen and (max-width: 767px){
            font-size: 28px;	
            line-height: 50px;
    }

    @media screen and (max-width: 575px){
            font-size: 26px;
            line-height: 48px;
    }
`;
export const BadgeList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 12px;
    margin-top: 20px;
`;
export const ListText = styled.p`
    padding-left: 28px;
    position: relative;
    margin-bottom: 0px; 

    &::before{
        position: absolute;
        background-image:url(${OrangeArrowIcon});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left top;
        content: '';
        width: 20px;
        height: 18px;
        top: 2px;
        left: 0px;
    }
`;
export const BadgeImage = styled.div`
    max-width: 362px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 20px;

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;
export const BeingSection = styled.section`
    width: 100%;
    background: #F1FEFF;
`;

export const BenefitsBeingImageWrap = styled.div`
    width: 100%;
    padding: 46px 20px;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    background: #fff;
    img{
        max-width: 350px;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        display: block;
    }
`;
export const BenefitsBeingTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 20px;
`;

export const BenefitsBeingList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 12px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    margin-top: 20px;
`;
export const BenefitsBeingListText = styled.p`
    padding-left: 28px;
    position: relative;
    margin-bottom: 0px;

    &::before{
        position: absolute;
        background-image:url(${OrangeArrowIcon});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left top;
        content: '';
        width: 20px;
        height: 18px;
        top: 2px;
        left: 0px;
    }
`;

export const QualifySection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 116px 0 0px;

    @media screen and (max-width: 767px){
         padding: 70px 0 0px;
    }
`;

export const QualifyWrap = styled.div`
    max-width: 588px;
    margin:0 auto;
    background: #FFFFFF;
    border: 1px solid #000000;
    border-radius: 15px;
    padding: 30px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
`;

export const QualifyTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 10px;
`;

export const QualifyText = styled.p`
    margin-bottom: 20px;
    &:last-child{
        margin-bottom: 0px;
    }
`;

export const ClaimYourSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;
`;

export const ClaimYourBox = styled.div`
    width: 100%;
    background: #F1FEFF;
    margin-top: 50px;
`;

export const ClaimYourSocialMedia = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: 20px;

    .social-media-requests-box-title{
        display:  none;
    }
    .social-media-requests-box-wrap{
        background: #fff;
    }

    h6{
        display: none;
        span{
            display: none;
        }
    } 
`;

export const ClaimYourBoxTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px;
    margin-bottom: 30px;
    text-align: center;
`;

export const TopRatedStatusBox = styled.div`
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
    column-gap: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const RatedStatusContent = styled.div`
    width: 100%;  
    max-width: 588px;
`;

export const RatedStatusText = styled.p`
    margin-bottom: 12px;
    text-align: left;
    &:last-child{
        margin-bottom: 0px;
    }
`;

export const RatedStatusList = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 12px 0px;
    margin-bottom: 20px;
`;

export const RatedStatusListText = styled.p`
    width: calc(50% - 10px);
    padding-left: 30px;
    position: relative;
    text-align: left;
    margin: 0;
   @media screen and (max-width:767px){
     width:100%;
   }
    &::before{
        position: absolute;
        background-image:url(${OrangeArrowIcon});
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left top;
        content: '';
        width: 20px;
        height: 18px;
        top: 2px;
        left: 0px;
    }
`;

export const RatedStatusImage = styled.div`
    width: 100%;
    max-width: 393px;
    height: 100%;
   background:#fff;
   border-radius: 20px;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;